import { render } from "./PublicStudentReview.vue?vue&type=template&id=61f2e024&scoped=true"
import script from "./PublicStudentReview.vue?vue&type=script&lang=js"
export * from "./PublicStudentReview.vue?vue&type=script&lang=js"

import "./PublicStudentReview.vue?vue&type=style&index=0&id=61f2e024&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61f2e024"]])

export default __exports__